<template>
  <div class="culture">
      <div class="banner">
        <img src="../../static/img/qywh_banner@2x.png" alt="">
      </div>
       <div class="qywh">
          <div class="title cent">
              <p> <span class="xian"></span><span class="title_txt">最新新闻</span></p>
          </div>
         <!-- 新闻列表内容 -->
          <ul class="qywh_cont">
            <li class="qywh_conts" v-for="(item,i) in news " :key="i"  @click="$router.push({path:item.path })"> 
                <div class="left" >
                    <h4>{{item.title}}</h4>
                    <span>时间：{{item.date}}</span>
                    <p style=" -webkit-box-orient: vertical;">{{item.xwnr}}</p>
                </div>
                <div class="right">
                    <img :src="item.img" alt="">
                </div>
            </li>

          </ul>
          <!-- 员工风采 -->
          <div class="title cent">
              <p> <span class="xian"></span><span class="title_txt">员工风采</span></p>
          </div>
            <!-- 员工风采轮播 -->
          <div class="fc_img">
              <!-- <img src="../../static/img/将康活佛那个日@2x.png" alt=""> -->
              <el-carousel :interval="3000" type="card" height="4.65rem">
                    <el-carousel-item v-for="(item,i) in fc_img" :key="i">
                         <img :src="item.img" alt="">
                    </el-carousel-item>
                </el-carousel>
          </div>
       </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data(){
    return{
      news: [
        {
          date: '2018-12-18',
          title: '热烈庆祝北京飞猪科技获得了“中关村高新技术企业”证书',
          xwnr: '近期，北京飞猪科技经过公司所有员工的共同努力，公司的规模和业务都得到了飞速的发展与提升，最令员工们激动与欣喜的事情——北京飞猪科技获得了“中关村高新技术企业”证书。',
          img: require('../../static/img/新闻1@2x.png'),
          path: '/newDetails?id=0'
        },
        {
          date: '2018-11-08',
          title: '北京飞猪科技董事长出席金融峰会并在当地调研',
          xwnr: '2018年11月6日-7日，集团公司董事长一行出席战略性互联互通示范项目金融峰会并在当地调研，期间分别拜会了市委书记和政府市长。集团公司副总裁、业务管理部和投资管理部主要负责人同志陪同。',
          img: require('../../static/img/新闻2@2x.png'),

          path: '/newDetails?id=1'
        },
        {
          date: '2018-08-14',
          title: '北京飞猪科技在上海分公司召开第二季度会议',
          xwnr: '8月14日，以“新起点、新高度，中国人力资源服务业回望与前瞻”为主题的第四届中国人力资源服务战略发展大会在北京隆重举办。来自各级人社部门，各人力资源服务行业组织和国内外人力资源服务机构的领导和专家参加了大会。北京外企人力资源服务有限公司（FESCO）总经理郝杰受邀出席活动并发表演讲。',
          img: require('../../static/img/新闻3@2x.png'),
          path: '/newDetails?id=2'
        },
        {
          date: '2018-07-16',
          title: '发展与改革势在必行！',
          xwnr: '经过一年的不断努力，各个部门业绩快速增长，比去年同期增长3倍以上，平均到每个人，也有超过1倍的增长，横向比较的话，我们一个人的业绩，超过多数同业公司一个TEAM的业绩。',
          img: require('../../static/img/新闻4@2x.png'),
          path: '/newDetails?id=3'
        //   path: '/fzxw?page=4&id=6'
        },
        {
          date: '2018-06-28',
          title: '北京飞猪科技车险保费跨越900亿，正在奋进行业前列',
          xwnr: '2018年6月28日，北京飞猪科技车险保费跨越900亿元，继2016年保费突破200亿元、2017年保费突破600亿元以后，再次实现了飞猪保险科技车险保费的历史性跨越，成为公司发展历程上重要的一笔历史记录。',
          img: require('../../static/img/新闻5@2x.png'),
          path: '/newDetails?id=4'
        //   path: '/fzxw?page=4&id=6'
        },
        {
          date: '2018-06-11',
          title: '离不开交流的技术与运营',
          xwnr: '在发展越来越快速的科技时代，技术可能就会不停的被人们提起来，大家都会认为技术已经是我们生活中不能离开的东西，它无时无刻不在影响着人们的生活，我们所看到的，听到的，感受的一切仿佛都和它息息相关，但是，往往人们会忘记一个更重要也可以说是和技术不可或缺的一个，那就是——运营。',
          img: require('../../static/img/新闻6@2x.png'),
          path: '/newDetails?id=5'
        //   path: '/fzxw?page=4&id=6'
        },
        {
          date: '2018-05-20',
          title: '北京飞猪科技技术部门召开关于太平专属APP的会议',
          xwnr: '2018年5月20日，北京飞猪科技有限公司在上海分公司召集所有技术部门，针对太平公司想要专属车险APP做出了详细的讨论',
          img: require('../../static/img/新闻7@2x.png'),
          path: '/newDetails?id=6'
        //   path: '/fzxw?page=4&id=6'
        }
        
      ],
      fc_img: [
          {
            img: require('../../static/img/将康活佛那个日@2x.png')
          },
          {
            img: require('../../static/img/鼓励员工大会@2x.png')
          },
          {
            img: require('../../static/img/积极共进@2x.png')
          },
          {
            img: require('../../static/img/欢乐颂年中聚会@2x.png')
          }
      ]
    }
  },
  mounted () {
    if(this.isMobile()) {
          this.$router.push({ path: "/culture" });
        } else {
          this.$router.push({ path: "/qywh?page=4" });
        }
  },
   methods: {
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
}
</script>
<style lang="scss" scoped>
.cent{
  margin: 0 auto;
  width: 92%;
  }
  .banner {
        width: 100%;
        height: 3.4rem;
        img {
            width: 100%;
            height: 100%;
        }
}
.qywh{
    .title{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: .3rem 0 .3rem .3rem;
            p{
                width: 1.8rem;
                color: #004b9e;
                font-size: .28rem;
                .title_txt{
                    padding-left: .2rem;
                    font-weight: 600;
                }
                .xian{
                    background-color: #054da0;
                    width: .06rem;
                    height: .28rem;
                    border-radius: .02rem ;
                    display: inline-block;
                }
            }
    }
    .qywh_cont{
        .qywh_conts{
            display: flex;
            justify-content: space-between;
            border-bottom: .2rem solid #fafafa;
            padding:.2rem .3rem;
            .left{
                width: 4.55rem;
                h4{
                    font-size: .26rem;
                    font-weight: 600;
                    line-height: .38rem;
                }
                span{
                    display: block;
                    font-size: .16rem;
                    line-height: .3rem;
                    padding: .3rem 0 .1rem 0;
                    color: #cdcdc8;
                }
                p{
                    font-size: .22rem;
                    line-height: .34rem;
                    color: #4b4c4f;
                    display: -webkit-box;
                    // -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .right{
                width: 2rem;
                height: 2rem;
                img{
                    display: block;
                    width: 2rem;
                    height: 2rem;
                }
            }
        }

    }
    .fc_img{
        padding: .2rem 0;
        img{
            display: block;
            // width: 5.4rem;
            // height: 4.65rem;
            width: 100%;
            height: 100%;
            margin: 0 auto;
        }
    }
}
 .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.5;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Culture.vue